import { excelReport } from "../../api/generateExcel-reports";

const generateExcel = {
  namespaced: true,
  state: () => ({
    excelFileData: null,
  }),
  getters: {
    getExcelFileData: (state) => {
      return state.excelFileData;
    },
  },
  actions: {
    generateExcelFile({ state, commit }, payload) {
      console.log(payload);
      return new Promise((resolve, reject) => {
        excelReport(payload)
          .then((file) => {
            resolve(file);
            state.excelFileData = file;
          })
          .catch((err) => {
            console.log("error while generating excel file data" + err);
          });
      });
    },
  },
  mutations: {},
};

export default generateExcel;
